'use client';
import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import PhoneNumberInput from '../components/PhoneNumberInput';
import type { InputProps } from '../ui/input';
import { FormControl } from './FormControl';

export function FormPhoneNumberInput({
  name,
  label,
  className,
  ...props
}: {
  name: string;
  label: string;
  className?: string;
} & InputProps) {
  const { register, getValues, formState, setValue } = useFormContext();

  return (
    <FormControl label={label} name={name}>
      <PhoneNumberInput
        disabled={props.disabled || formState.isSubmitting}
        className={cn('w-full', className)}
        {...register(name)}
        value={getValues(name)}
        onChange={(e) => {
          register(name).onChange(e);
          setValue(name, e.target.value.replace(/\D/g, ''));
        }}
      />
    </FormControl>
  );
}
